<div class="pt-5 pb-3 text-center">
    <img class="d-block mx-auto mb-4" src="/assets/images/logo-hf-3.png" alt="Hércules Formación">
    <div class="exception-panel">
        <h1>ERROR</h1>
        <p>La página que buscas no existe</p>
    </div>
</div>